import { Backdrop, CircularProgress, Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React, { FunctionComponent, useState } from "react";
import { AppTheme } from "../AppTheme";

const notYetRendered = "Page loader not yet rendered.";

/**
 * Page loader options interface, exposes methods for showing and hiding the element.
 */
export interface PageLoaderOptions {
	show: () => void;
	hide: () => void;
}

/**
 * Page loader properties. Contains page loader options.
 */
type PageLoaderProps = {
	options: PageLoaderOptions;
}

/**
 * Gets default page loader options.
 * @returns PageLoaderOptions
 */
export const getDefaultPageLoaderOptions = () => {
	return {
		notYetRendered: "page loader not yet rendered",
		show() {
			console.warn(notYetRendered);
		},
		hide() {
			console.warn(notYetRendered);
		}
	} as PageLoaderOptions
};

// configure styles for the backdrop
const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: AppTheme.zIndex.drawer + 1,
			color: AppTheme.palette.primary.main
		}
	})
);

/**
 * Page loader component, when rendered, a loading circular progress animation and backdrop is displayed over the page.
 * @param props Page loader properties.
 */
export const PageLoader: FunctionComponent<PageLoaderProps> = (props: PageLoaderProps) => {

	// setup initial state (not visible)
	const [state, setState] = useState({
		open: false
	});

	const classes = useStyles();

	// apply show handler, making the rendered component showable to the caller
	props.options.show = () => {

		setState({
			open: true
		});
	}

	// apply hide handler, making the rendered component showable to the caller
	props.options.hide = () => {

		setState({
			open: false
		});
	}

	// output the loader and backdrop components
	return (
		<div>
			<Backdrop className={classes.backdrop} open={state.open}>
				<CircularProgress color="inherit" />
			</Backdrop>
		</div>
	);
};